
<template>
    <el-autocomplete 
      
        :disabled="Dezactivat"
        v-model="NumeProdusMutable" 
        placeholder="Cauta masina"
        :trigger-on-focus="false"
        :fetch-suggestions="querySearch" 
        @select="handleSelectMasina">      
        <template slot-scope="{ item }">
            <div class="nume">{{ item.Numar }}</div>
        </template>
    </el-autocomplete>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";

export default {
    name: "SelectMasina",
    extends: BasePage,
    props: {
        value: {
            required: true,
        },
        IdMasina:{
            required:false
        },
        Dezactivat:{
            default: false,
            required:false
        }
    },
    computed: {
        NumeProdusMutable: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    data () {
        return {
            Results: [],
            loading : true,
            numarMasina:''       
        }
    },
    methods: {

        async querySearch(queryString, cb) {

            if (!queryString) {
                queryString = ''
            }
            
            var response = await this.post('admin/masini/get_masini', {
                queryString: queryString
            })
            cb(response.Products)
        },
        handleSelectMasina(item){
            var produsObj           = item.Masina
            this.lastSelected       = produsObj
            this.NumeProdusMutable  = produsObj.Numar
            
            this.$emit('update:IdMasina',produsObj.Id)
            this.$emit('selectie', produsObj)
        }
    },
    mounted(){
    }
};
</script>

<style lang="less" >

   .margin-bottom30 {
      margin-bottom:30px;
    }

</style>
